export const getDefaultOnlineAssessmentState = () => {
    return {
        banks: [],
    };
};
export const state = getDefaultOnlineAssessmentState();
